/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Show_MoreInputs */

const en_us2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

const pt_br2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar mais`)
};

const es_419_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar más`)
};

const pt_pt2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar mais`)
};

const fr_fr2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir plus`)
};

const de_de2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr anzeigen`)
};

const it_it2_plan_build_show_more = /** @type {(inputs: Plan_Build_Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra altri`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Plan_Build_Show_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_show_more = /** @type {((inputs?: Plan_Build_Show_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Show_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_show_more(inputs)
	if (locale === "es-419") return es_419_plan_build_show_more(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_show_more(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_show_more(inputs)
	if (locale === "de-DE") return de_de2_plan_build_show_more(inputs)
	if (locale === "it-IT") return it_it2_plan_build_show_more(inputs)
	return en_us2_plan_build_show_more(inputs)
});
export { plan_build_show_more as "plan-build.show_more" }